module.exports = __webpack_public_path__ + "static/media/5DPO4.0a7d28d2.jpg";